<template>
    <UDropdownMenu
        size="sm"
        :items="items"
    >
        <UButton
            icon="i-ph-dots-three-vertical"
            size="sm"
            variant="ghost"
            color="neutral"
            @click.stop
        />
    </UDropdownMenu>
</template>

<script setup lang="ts">

import {Assignment} from '@/assignments/Assignment.type'
import {computed, ref} from 'vue'
import {completeAssignment, deleteAssignment, detailsVisible} from '@/assignments/assignment.service'
import {notifyError} from '@/services/infrastructure/notification.service'
import {DropdownMenuItem} from '@nuxt/ui'
import {ICellRendererParams} from 'ag-grid-community'

const props = defineProps({
    assignment: {
        type: Object as () => Assignment,
        required: true
    },
    params: {
        type: Object as () => ICellRendererParams,
        required: false
    },
})

const isLoading = ref(false)

const handleDelete = async() => {
    isLoading.value = true
    try {
        await deleteAssignment(props.assignment.uuid)
    }
    catch (error) {
        notifyError({ title: 'Noe gikk galt', description: { descriptionMessage: 'Klarte ikke slette oppgaven', error}})
    }
    finally {
        isLoading.value = false
    }
}

const handleComplete = async () => {
    isLoading.value = true
    try {
        await completeAssignment(props.assignment.uuid)
    }
    catch (error) {
        notifyError({ title: 'Noe gikk galt', description: { descriptionMessage: 'Klarte ikke fullføre oppgaven', error}})
    }
    finally {
        isLoading.value = false
    }
}

const handleDetails = () => {
    props.params?.context.openAssignmentDetails(props.assignment.uuid)
    detailsVisible.value = true
}

const handleEdit = () => {
    props.params?.context.openEditAssignmentPopup(props.assignment.uuid)
}

const items = computed<DropdownMenuItem[]>(() => {
    const dynamicItemsFirstBulk = []
    dynamicItemsFirstBulk.push({
        label: 'Vis detaljer',
        icon: 'i-ph-info',
        value: 'details',
        onSelect: handleDetails
    })
    dynamicItemsFirstBulk.push({
        label: 'Rediger oppgave',
        icon: 'i-ph-pencil',
        value: 'edit',
        onSelect: handleEdit
    })
    if (props.assignment?.status === 'pending') {
        dynamicItemsFirstBulk.push({
            label: 'Marker som fullført',
            icon: 'i-ph-seal-check',
            value: 'complete',
            onSelect: handleComplete
        })
    }

    const dynamicItemsSecondBulk = []
    if (!props.assignment.deletedAt) {
        dynamicItemsSecondBulk.push({
            label: 'Slett oppgave',
            value: 'delete',
            icon: 'i-ph-trash',
            color: 'error',
            onSelect: handleDelete,

        })
    }
    return [dynamicItemsFirstBulk, dynamicItemsSecondBulk]
})
</script>

<style scoped>

</style>